import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f8e9335"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6f8e9335&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f8e9335')) {
      api.createRecord('6f8e9335', component.options)
    } else {
      api.reload('6f8e9335', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6f8e9335", function () {
      api.rerender('6f8e9335', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/new-client/index.vue"
export default component.exports